export * from "./google";
export * from "./nav";
export * from "./firebase";
export * from "./reachouts";

// ============ APP CONFIG ============
// Dev
export const isDev =
  process.env.VERCEL_ENV === "development" ||
  process.env.NEXT_PUBLIC_VERCEL_ENV === "development" ||
  process.env.NODE_ENV === "development";

// Staging
export const isPreview =
  process.env.VERCEL_ENV === "preview" ||
  process.env.NEXT_PUBLIC_VERCEL_ENV === "preview";

export const helpEmail = "hello@joincape.ai";

// ============ BROWSER EXTENSION ============
export const CHROME_EXTENSION_DL_URL =
  isPreview || isDev
    ? "https://chromewebstore.google.com/u/3/detail/cape-staging/adncecocccablbifnjnbgafcicmgojig?hl=en"
    : "https://chromewebstore.google.com/u/3/detail/cape/bjnldcpbkcoeamhmjkmmcffmblcfkfnk?hl=en";

export const LINKEDIN_SIGNIN_URL =
  "https://www.linkedin.com/login?fromSignIn=true&trk=guest_homepage-basic_nav-header-signin";

export function isWhitelisted(email: string) {
  return (
    email.endsWith("@supercharge.finance") ||
    email.endsWith("@joincape.ai") ||
    email === "jim32990@gmail.com" ||
    email === "eunicehx920@gmail.com" ||
    email === "ben.gusberg@gmail.com" ||
    email === "bgusberg@gmail.com"
  );
}

export const conferenceTermsUrl =
  "https://docs.google.com/document/d/1WjCvKJCpd-Vlf0IpXbMrDPzZYYNBcy6lBIC-6cr72s0/edit?tab=t.0";
export const conferencePrivacyUrl =
  "https://docs.google.com/document/d/1XuinvgXFL6qpA4LXjnd-0hrS3nf4H_a3t53KllVDbtk/edit?tab=t.0";
